import { VariableType } from "../VariableType";
import { BaseTypeSchema } from "../BaseTypeSchema";

export class EnumSchema extends BaseTypeSchema
{
    name: string;
    external: { package: string } | null = null;
    constructor(name: string, required: boolean, enumObj: { [key: string]: string } | string[])
    {
        super(VariableType.Enum, required);
        this.name = name;
        if (Array.isArray(enumObj))
            this.setValid(...enumObj);
        else
            this.setValid(...Object.values(enumObj));
    }
    setExternal(external: { package: string } | null): EnumSchema
    {
        this.external = external;
        return this;
    }
}